<template>
  <ElDialog
    :visible="visible"
    width="100%"
    class="guest-extras-dialog"
    append-to-body
    @close="$emit('close')"
  >
    <p
      slot="title"
      data-private
      class="font-bold text-lg text-primary truncate pr-20"
    >
      {{ guest ? guest.fullName : '' }}
    </p>

    <div
      v-if="guest"
      class="text-center"
    >
      <p class="text-base text-primary-light mb-20">Extra guests checked in</p>

      <div class="flex items-center justify-center mb-25">
        <ElButton
          circle
          :disabled="count <= 0 || saving"
          title="Uncheck one extra guest"
          class="stepper-button"
          @click="count -= 1"
        >
          <span class="font-bold leading-none">&minus;</span>
        </ElButton>
        <p class="font-bold text-4xl text-primary leading-none mx-30">
          {{ count }}<span class="font-medium text-2xl text-primary-light"> / {{ total }}</span>
        </p>
        <ElButton
          circle
          :disabled="count >= total || saving"
          title="Check in one extra guest"
          class="stepper-button stepper-button-add"
          @click="count += 1"
        >
          <span class="font-bold leading-none">+</span>
        </ElButton>
      </div>

      <div class="flex justify-center">
        <ElButton
          size="small"
          :disabled="count === 0 || saving"
          @click="count = 0"
        >
          Uncheck all
        </ElButton>
        <ElButton
          size="small"
          :disabled="count === total || saving"
          @click="count = total"
        >
          Check in all
        </ElButton>
      </div>
    </div>

    <div
      slot="footer"
      class="flex items-center"
    >
      <ElButton
        type="primary"
        :loading="saving"
        :disabled="!guest || count === (guest.checkedInExtraGuests || 0)"
        @click="$emit('save', count)"
      >
        Save
      </ElButton>
      <button
        type="button"
        class="font-medium text-secondary ml-20 hover:underline"
        @click="$emit('close')"
      >
        Cancel
      </button>
    </div>
  </ElDialog>
</template>

<script>
// Check in / uncheck the extra guests of one guest. Writes the same `checkedInExtraGuests` counter the Android
// check-in screen uses (0..totalExtraGuests), independent of the main guest status.
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    guest: {
      type: Object,
      default: null,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    count: 0,
  }),
  computed: {
    total() {
      return this.guest?.totalExtraGuests || 0;
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(isVisible) {
        if (!isVisible || !this.guest) return;

        this.count = Math.min(this.guest.checkedInExtraGuests || 0, this.total);
      },
    },
  },
};
</script>

<style>
.guest-extras-dialog .el-dialog {
  max-width: 380px;
  width: calc(100% - 32px) !important;
}

.guest-extras-dialog .stepper-button {
  @apply text-xl;

  width: 52px;
  height: 52px;
}

/* Eventor brand gold, same as the primary actions (Add guest, Save) */
.guest-extras-dialog .stepper-button-add:not(.is-disabled) {
  @apply text-white bg-secondary border-secondary;
}
</style>
